import { DateTime } from 'luxon'

import { capitalizeString, digObject } from '@domain-group/javascript-utils'

import { Box, ListItem, Text } from '@domain-group/suit-theme'

import usePublication from '@hooks/usePublication'

interface DeadlineListItemProps {
  deadline: any,
  userTimeZone: string,
}

const DeadlineListItem = (props: DeadlineListItemProps) => {
  const { deadline, userTimeZone } = props

  const {
    deadlineType,
    deadlineDate,
    description: customDeadlineSubtitle,
    id,
    publicationDate,
    publicationId,
    relativeDate,
    title: customDeadlineTitle,
  } = deadline

  const publicationPayload = usePublication({ id: publicationId })
  const { publication } = publicationPayload || {}

  const actualTitle = publication?.title || customDeadlineTitle
  const subtitle = customDeadlineSubtitle || `${publicationDate?.toFormat('d MMMM yyyy')} Edition`

  const customDeadlineTimeString = digObject(deadline, 'dates.deadline.time')

  const dueTimeObject = customDeadlineTimeString ? DateTime.fromFormat(customDeadlineTimeString, 'HH:mm') : undefined

  const actualRelativeDate = dueTimeObject?.toRelative() || relativeDate

  const deadlinePassed = dueTimeObject
    ? dueTimeObject < DateTime.now().setZone(userTimeZone)
    : deadlineDate < DateTime.now().setZone(userTimeZone)

  return (
    <ListItem
      boxProps={{
        borderBottom: '1px solid',
        opacity: deadlinePassed ? 0.5 : 1,
        paddingX: 'large',
        paddingY: 'large',
      }}
      disableHover
      key={`${deadlineType}-${id}`}
    >
      <Box flexDirection="column" fontSize="small">
        <Text lineHeight={1.3}>{actualTitle}</Text>

        <Text color="bodyFontLightColor" fontSize="xsmall" marginTop="medium">
          {subtitle}
        </Text>

        <Text fontSize="xsmall" marginTop="medium">
          {deadlineType ? `${capitalizeString(deadlineType)} due ${actualRelativeDate}` : `Due ${actualRelativeDate}`}
        </Text>
      </Box>
    </ListItem>
  )
}

export default DeadlineListItem
